import angular, { IOnInit } from "angular";
import {
  FormSubmitArgs,
  FormViewConfig,
  FormViewController,
} from "../../../../records/forms/formView";
import { LookupModalOptions } from "./service";

export class LookupModalController implements IOnInit {
  static $inject = [];

  /* bindings */
  readonly modalInstance!: angular.ui.bootstrap.IModalInstanceService;
  readonly resolve!: {
    config: LookupModalOptions;
    formViewConfig: FormViewConfig;
    model: any;
    onSubmit: [
      ...string[],
      (args: FormSubmitArgs) => [...string[], Promise<any>]
    ];
    onCancel: [
      ...string[],
      (args: FormSubmitArgs) => [...string[], Promise<any>]
    ];
  };
  /* bindings */

  constructor() {
    this.setModalWidth("950px");
  }

  $onInit() {}

  private setModalWidth(width: string) {
    const elements = document.querySelector(".modal-content");
    if (!elements) return;
    var modalWindow = angular.element(elements);
    modalWindow.css("width", width);
  }
}
